import React from "react";
import Context from "../../Context";
import Blocker from "./Blocker";
import TablerowAdjButtons from "./TablerowAdjButtons";

export default class JsonformNested extends React.Component {
  static contextType = Context;

  render() {
    let fields = this.props.field?.subform || [];
    const columnsLabels = fields.map((f) => f.label);

    const columnsWidth =
      columnsLabels.length > 0 ? 100 / columnsLabels.length : 100;

    const key = this.props.field?.key;
    let rows = this.props.formData[key] || [];

    return (
      <>
        {fields.length > 0 && (
          <div className="table-responsive1">
            <table className="table">
              <thead>
                <tr>
                  <th>
                    <i
                      title="Добавить строку"
                      onClick={() => this.props.rowAdd(0, key)}
                      className="fa fa-plus cursor-pointer text-hover-primary mr-3"
                    ></i>
                  </th>
                  {columnsLabels.map((c, idx) => (
                    <th width={`${columnsWidth}%`} key={idx}>
                      {c}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, rowIndex) => {
                  return (
                    <tr key={rowIndex}>
                      <td width={50}>
                        <TablerowAdjButtons
                          idx={rowIndex}
                          rowAdd={() => this.props.rowAdd(rowIndex + 1, key)}
                          rowUp={() => this.props.rowUp(rowIndex, key)}
                          rowRemove={() => this.props.rowRemove(rowIndex, key)}
                          rowDown={() => this.props.rowDown(rowIndex, key)}
                        />
                      </td>
                      {fields.map((field, fieldIndex) => {
                        return (
                          <td key={fieldIndex}>
                            {this.props.renderInput({
                              ...field,
                              rowIndex,
                              parentKey: key,
                            })}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </>
    );
  }
}
